import * as React from 'react';
import { SVGProps } from 'react';

const IconItalicSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 2v2h2.58l-3.66 8H2v2h8v-2H7.42l3.66-8H14V2H6z" />
  </svg>
);
export default IconItalicSizeS;
